export const search = searchTerm => ({
	type: 'SEARCH',
	payload: searchTerm
})



// WEBPACK FOOTER //
// ./src/actions/searchActions.js